import React from 'react';
import defaultLogoImage from '../assets/branding/allowtru-logo-full.png';
import dashboardLogoImage from '../assets/branding/allowtru-logo-dashboard.png';
import './BrandLogo.css';

const sizeMap = {
  xs: {
    size: 28,
  },
  sm: {
    size: 36,
  },
  md: {
    size: 48,
  },
  lg: {
    size: 72,
  },
};

const BrandLogo = ({
  variant = 'full',
  tone = 'light',
  size = 'md',
  asset = 'default',
  className = '',
  style,
  alt = 'Allowtru Logo',
}) => {
  const config = sizeMap[size] || sizeMap.md;
  const dimension = config.size;
  const logoImage = asset === 'dashboard' ? dashboardLogoImage : defaultLogoImage;
  const logoClassName = variant === 'mark'
    ? 'brand-logo__image brand-logo__image--square'
    : 'brand-logo__image brand-logo__image--square';

  return (
    <span className={`brand-logo brand-logo--${tone} ${className}`.trim()} style={style}>
      <img
        src={logoImage}
        alt={alt}
        className={logoClassName}
        style={{
          width: dimension,
          height: dimension,
        }}
        draggable="false"
      />
    </span>
  );
};

export default BrandLogo;
